<template>
  <div class="user-app-card-wrapper">
    <el-card>
      <div slot="header">
        应用名：{{  userApp.app_store_detail.app_name_i18n[0].name  }}
      </div>

      <div class="user-app-info">
        <div class="label-info">
          <p>应用分类:</p>
          <p>{{ userApp.app_store_detail.app_category_name_i18n[0].name }}</p>
        </div>
        <div class="label-info">
          <p>开始时间:</p>
          <p>{{ userApp.start_at | dateformat }}</p>
        </div>
        <div class="label-info">
          <p>过期时间:</p>
          <p>{{ userApp.expire_at | dateformat }}</p>
        </div>
      </div>

      <div class="user-app-op">
        <el-button
          type="text"
          @click="onEditClick">修改</el-button>
        <el-button
          type="text"
          class="danger-text"
          @click="onDeleteClick">删除</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserAppCard',
  props: {
    userApp: {
      type: Object,
      required: true
    }
  },
  methods: {
    onEditClick () {
      this.$emit('edit', this.userApp)
    },
    onDeleteClick () {
      this.$emit('delete', this.userApp)
    }
  }
}
</script>

<style lang="scss" scoped>

.user-app-card-wrapper {
  width: 23%;
  padding: 10px;

  .user-app-info {

    .label-info {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    p {
      line-height: 1.5;
      margin: 0;
    }
  }

  .user-app-op {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/UserAppCard.vue